// About Page - Can Çağatay Çelikkol
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { translations } from './translations';

// Social Media Icons (inline SVGs)
const TwitterIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
);

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
);

// Logo
const LOGO_ICON = "https://customer-assets.emergentagent.com/job_event-booking-pro-7/artifacts/6r7gbjry_logo%20800x800.png";

// About Page Content
const aboutContent = {
  tr: {
    pageTitle: 'Can Çağatay Çelikkol | Kurucu & Danışman',
    metaDesc: 'Nova Iberian kurucusu Can Çağatay Çelikkol hakkında. İspanya oturum izni, şirket kurulumu ve yatırım danışmanlığı konusunda uzman.',
    heroTitle: 'Can Çağatay Çelikkol',
    heroSubtitle: 'Kurucu & Baş Danışman',
    backToHome: '← Ana Sayfa',
    biography: {
      title: 'Hakkımda',
      paragraphs: [
        'Merhaba, ben Can Çağatay Çelikkol. Nova Iberian Consulting Group\'un kurucusuyum. İspanya\'da yaşayan bir Türk girişimci olarak, ülkemizin insanlarının Avrupa\'daki hayallerini gerçekleştirmelerine yardımcı oluyorum.',
        'Yıllar içinde edindiğim deneyim ve uluslararası iş dünyasına olan tutkum, beni İspanya\'ya taşıdı. Barcelona\'da hem kendi işimi kurdum hem de bu süreçte yaşadığım zorlukları, kazandığım deneyimleri başkalarıyla paylaşmaya karar verdim.',
        'Nova Iberian\'ı kurma fikri, kendi göç ve şirket kurma süreçlerimde yaşadığım deneyimlerden doğdu. Dil bariyeri, bürokratik karmaşıklıklar ve güvenilir bilgiye ulaşmanın zorluğu... Tüm bunları bizzat yaşadım. Şimdi ise bu süreci sizin için kolaylaştırmak istiyorum.',
        'Bugün Nova Iberian olarak, İspanya\'ya yerleşmek isteyen Türk vatandaşlarına kapsamlı danışmanlık hizmetleri sunuyoruz. Oturum izni başvurularından şirket kuruluşuna, gayrimenkul yatırımından vergi planlamasına kadar geniş bir yelpazede hizmet veriyoruz.',
        'Amacımız sadece bir danışmanlık şirketi olmak değil; İspanya\'daki Türk topluluğunun güvenilir bir köprüsü olmaktır. Her müşterimizin hikayesi benzersizdir ve biz de her birine özel çözümler üretiyoruz.'
      ]
    },
    expertise: {
      title: 'Uzmanlık Alanlarım',
      items: [
        'İspanya Oturum İzinleri (Digital Nomad, Girişimci, Non-Lucrative)',
        'Şirket Kurulumu (Autónomo, SL, Sucursal)',
        'Gayrimenkul Yatırım Danışmanlığı',
        'Beckham Kanunu Vergi Avantajları',
        'Golden Visa Programı',
        'Uluslararası Vergi Planlaması'
      ]
    },
    social: {
      title: 'Sosyal Medya',
      instagram: 'Instagram\'da Takip Et',
      youtube: 'YouTube Kanalımız',
      linkedin: 'LinkedIn Profili'
    },
    cta: {
      title: 'Benimle Çalışmak İster Misiniz?',
      text: 'İspanya\'daki hedeflerinizi birlikte gerçekleştirelim. Ücretsiz ön görüşme için randevu alın.',
      button: 'Randevu Al →'
    }
  },
  en: {
    pageTitle: 'Can Çağatay Çelikkol | Founder & Consultant',
    metaDesc: 'About Can Çağatay Çelikkol, founder of Nova Iberian. Expert in Spain residence permits, company formation and investment consulting.',
    heroTitle: 'Can Çağatay Çelikkol',
    heroSubtitle: 'Founder & Lead Consultant',
    backToHome: '← Home',
    biography: {
      title: 'About Me',
      paragraphs: [
        'Hello, I\'m Can Çağatay Çelikkol, founder of Nova Iberian Consulting Group. As a Turkish entrepreneur living in Spain, I help people from my country realize their dreams in Europe.',
        'Over the years, my experience and passion for international business brought me to Spain. In Barcelona, I established my own business and decided to share the challenges I faced and the experiences I gained with others.',
        'The idea of founding Nova Iberian was born from my own migration and company formation experiences. Language barriers, bureaucratic complexities, and the difficulty of accessing reliable information... I experienced all of these firsthand. Now I want to make this process easier for you.',
        'Today at Nova Iberian, we provide comprehensive consulting services to Turkish citizens who want to settle in Spain. We serve a wide range from residence permit applications to company formation, from real estate investment to tax planning.',
        'Our goal is not just to be a consulting company; it is to be a reliable bridge for the Turkish community in Spain. Each client\'s story is unique, and we create customized solutions for each one.'
      ]
    },
    expertise: {
      title: 'My Expertise',
      items: [
        'Spain Residence Permits (Digital Nomad, Entrepreneur, Non-Lucrative)',
        'Company Formation (Autónomo, SL, Sucursal)',
        'Real Estate Investment Consulting',
        'Beckham Law Tax Benefits',
        'Golden Visa Program',
        'International Tax Planning'
      ]
    },
    social: {
      title: 'Social Media',
      instagram: 'Follow on Instagram',
      youtube: 'Our YouTube Channel',
      linkedin: 'LinkedIn Profile'
    },
    cta: {
      title: 'Want to Work With Me?',
      text: 'Let\'s achieve your goals in Spain together. Book a free consultation.',
      button: 'Book Appointment →'
    }
  },
  es: {
    pageTitle: 'Can Çağatay Çelikkol | Fundador y Consultor',
    metaDesc: 'Sobre Can Çağatay Çelikkol, fundador de Nova Iberian. Experto en permisos de residencia en España, constitución de empresas y consultoría de inversión.',
    heroTitle: 'Can Çağatay Çelikkol',
    heroSubtitle: 'Fundador y Consultor Principal',
    backToHome: '← Inicio',
    biography: {
      title: 'Sobre Mí',
      paragraphs: [
        'Hola, soy Can Çağatay Çelikkol, fundador de Nova Iberian Consulting Group. Como empresario turco que vive en España, ayudo a las personas de mi país a realizar sus sueños en Europa.',
        'A lo largo de los años, mi experiencia y pasión por los negocios internacionales me trajeron a España. En Barcelona, establecí mi propio negocio y decidí compartir los desafíos que enfrenté y las experiencias que obtuve con otros.',
        'La idea de fundar Nova Iberian nació de mis propias experiencias de migración y constitución de empresas. Barreras del idioma, complejidades burocráticas y la dificultad de acceder a información confiable... Experimenté todo esto de primera mano. Ahora quiero facilitar este proceso para usted.',
        'Hoy en Nova Iberian, proporcionamos servicios integrales de consultoría a ciudadanos turcos que desean establecerse en España. Servimos una amplia gama desde solicitudes de permiso de residencia hasta constitución de empresas, desde inversión inmobiliaria hasta planificación fiscal.',
        'Nuestro objetivo no es solo ser una empresa de consultoría; es ser un puente confiable para la comunidad turca en España. La historia de cada cliente es única, y creamos soluciones personalizadas para cada uno.'
      ]
    },
    expertise: {
      title: 'Mi Especialización',
      items: [
        'Permisos de Residencia en España (Nómada Digital, Emprendedor, No Lucrativo)',
        'Constitución de Empresas (Autónomo, SL, Sucursal)',
        'Consultoría de Inversión Inmobiliaria',
        'Beneficios Fiscales de la Ley Beckham',
        'Programa Golden Visa',
        'Planificación Fiscal Internacional'
      ]
    },
    social: {
      title: 'Redes Sociales',
      instagram: 'Seguir en Instagram',
      youtube: 'Nuestro Canal de YouTube',
      linkedin: 'Perfil de LinkedIn'
    },
    cta: {
      title: '¿Quiere Trabajar Conmigo?',
      text: 'Logremos juntos sus objetivos en España. Reserve una consulta gratuita.',
      button: 'Reservar Cita →'
    }
  }
};

export const AboutPage = ({ lang, setLang }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const navigate = useNavigate();
  
  const currentLang = lang || 'tr';
  const content = aboutContent[currentLang] || aboutContent.tr;
  const t = translations[currentLang] || translations.tr;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    window.scrollTo(0, 0);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app" data-testid="about-page">
      <Helmet>
        <title>{content?.pageTitle ? `${content.pageTitle} | Nova Iberian` : 'Can Çağatay Çelikkol | Nova Iberian'}</title>
        <meta name="description" content={content?.metaDesc || 'Nova Iberian kurucusu Can Çağatay Çelikkol hakkında.'} />
        <link rel="canonical" href="https://novaiberian.com/can-cagatay-celikkol" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content={content?.pageTitle || 'Can Çağatay Çelikkol'} />
        <meta property="og:description" content={content?.metaDesc || ''} />
        <meta property="og:url" content="https://novaiberian.com/can-cagatay-celikkol" />
        <meta property="og:image" content="https://novaiberian.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={content?.pageTitle || 'Can Çağatay Çelikkol'} />
        <meta name="twitter:description" content={content?.metaDesc || ''} />
      </Helmet>

      {/* Navigation - Same as main page */}
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
        <div className="nav-inner">
          <Link to="/" className="nav-logo" data-testid="nav-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="nav-logo-icon" />
            <span className="nav-logo-text">Nova <span>Iberian</span></span>
          </Link>
          
          <div className="nav-links">
            <Link to="/#hizmetler">{t.nav.services}</Link>
            <Link to="/can-cagatay-celikkol">{t.nav.about}</Link>
            <Link to="/#referanslar">{t.nav.testimonials}</Link>
            <Link to="/#ispanya-bilgisi">{t.nav.guide}</Link>
            <Link to="/blog">{t.nav.blog}</Link>
            <Link to="/#iletisim">{t.nav.contact}</Link>
            
            <div className="nav-social-icons">
              <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
              <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
              <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
              <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
              <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
            </div>
          </div>
          
          <div className="nav-right">
            <div className="lang-dropdown" data-testid="lang-switcher">
              <button 
                className="lang-dropdown-btn"
                onClick={() => setLangDropdownOpen(!langDropdownOpen)}
                data-testid="lang-dropdown-btn"
              >
                <span className="lang-code">{currentLang === 'tr' ? 'TR' : currentLang === 'en' ? 'EN' : 'ES'}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>
              {langDropdownOpen && (
                <div className="lang-dropdown-menu">
                  <button 
                    className={`lang-dropdown-item ${currentLang === 'tr' ? 'active' : ''}`}
                    onClick={() => { setLang('tr'); setLangDropdownOpen(false); }}
                  >
                    Türkçe
                  </button>
                  <button 
                    className={`lang-dropdown-item ${currentLang === 'en' ? 'active' : ''}`}
                    onClick={() => { setLang('en'); setLangDropdownOpen(false); }}
                  >
                    English
                  </button>
                  <button 
                    className={`lang-dropdown-item ${currentLang === 'es' ? 'active' : ''}`}
                    onClick={() => { setLang('es'); setLangDropdownOpen(false); }}
                  >
                    Español
                  </button>
                </div>
              )}
            </div>
            <Link to="/#randevu" className="btn-nav" data-testid="nav-cta">{t.nav.appointment}</Link>
            
            <button 
              className="mobile-menu-btn" 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
        
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-social-icons">
            <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
            <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
            <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
            <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
            <a href="https://www.tiktok.com/@nova_iberian" target="_blank" rel="noopener noreferrer"><TikTokIcon /></a>
          </div>
          <Link to="/#hizmetler" onClick={() => setMobileMenuOpen(false)}>{t.nav.services}</Link>
          <Link to="/can-cagatay-celikkol" onClick={() => setMobileMenuOpen(false)}>{t.nav.about}</Link>
          <Link to="/#referanslar" onClick={() => setMobileMenuOpen(false)}>{t.nav.testimonials}</Link>
          <Link to="/#ispanya-bilgisi" onClick={() => setMobileMenuOpen(false)}>{t.nav.guide}</Link>
          <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>{t.nav.blog}</Link>
          <Link to="/#iletisim" onClick={() => setMobileMenuOpen(false)}>{t.nav.contact}</Link>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <Link to="/" className="about-back-link">{content.backToHome}</Link>
          <h1>{content.heroTitle}</h1>
          <p className="about-hero-subtitle">{content.heroSubtitle}</p>
          <div className="about-hero-social">
            <a href="https://x.com/IberianNov846" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a>
            <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
            <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a>
            <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
            <a href="mailto:info@novaiberian.com"><EmailIcon /></a>
          </div>
        </div>
      </section>

      {/* Biography Section */}
      <section className="about-content-section">
        <div className="about-content-inner">
          <h2>{content.biography.title}</h2>
          {content.biography.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>

      {/* Expertise Section */}
      <section className="about-expertise-section">
        <div className="about-content-inner">
          <h2>{content.expertise.title}</h2>
          <ul className="about-expertise-list">
            {content.expertise.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* Social Media Section with Screenshots */}
      <section className="about-social-section">
        <div className="about-content-inner">
          <h2>{content.social.title}</h2>
          <div className="about-social-grid">
            {/* Instagram Card */}
            <a href="https://www.instagram.com/nova_iberian" target="_blank" rel="noopener noreferrer" className="about-social-card">
              <div className="about-social-card-image instagram-placeholder">
                <InstagramIcon />
                <span>@nova_iberian</span>
              </div>
              <div className="about-social-card-label">
                <InstagramIcon />
                <span>{content.social.instagram}</span>
              </div>
            </a>
            
            {/* YouTube Card */}
            <a href="https://youtube.com/@cancagataycelikkol?si=dDAtv-bmmLjSZ-FW" target="_blank" rel="noopener noreferrer" className="about-social-card">
              <div className="about-social-card-image youtube-placeholder">
                <YouTubeIcon />
                <span>@cancagataycelikkol</span>
              </div>
              <div className="about-social-card-label">
                <YouTubeIcon />
                <span>{content.social.youtube}</span>
              </div>
            </a>
            
            {/* LinkedIn Card */}
            <a href="https://www.linkedin.com/company/nova-iberian-consulting-group-limited-company/" target="_blank" rel="noopener noreferrer" className="about-social-card">
              <div className="about-social-card-image linkedin-placeholder">
                <LinkedInIcon />
                <span>Nova Iberian</span>
              </div>
              <div className="about-social-card-label">
                <LinkedInIcon />
                <span>{content.social.linkedin}</span>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta-section">
        <div className="about-content-inner">
          <h2>{content.cta.title}</h2>
          <p>{content.cta.text}</p>
          <Link to="/#randevu" className="btn-primary">{content.cta.button}</Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-logo">
            <img src={LOGO_ICON} alt="Nova Iberian" className="footer-logo-icon" />
            <span className="footer-logo-text">Nova <span>Iberian</span></span>
          </div>
          <p className="footer-text">© 2025 Nova Iberian Consulting Group S.L.</p>
          <div className="footer-links">
            <Link to="/cerez-politikasi">{currentLang === 'tr' ? 'Çerez Politikası' : currentLang === 'en' ? 'Cookie Policy' : 'Política de Cookies'}</Link>
            <Link to="/aydinlatma-metni">{currentLang === 'tr' ? 'Gizlilik Politikası' : currentLang === 'en' ? 'Privacy Policy' : 'Política de Privacidad'}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
